import { SegmentGroup as ArkSegmentGroup } from '@ark-ui/react';

import type { Radius, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type SegmentedControlRootProps = ArkSegmentGroup.RootProps & {
	size?: Scale3;
	variant?: 'surface' | 'classic';
	radius?: Radius;
};

function SegmentedControlRoot({
	className,
	size = '2',
	variant = 'surface',
	radius,
	...props
}: SegmentedControlRootProps) {
	return (
		<ArkSegmentGroup.Root
			className={cn('pt-segmented-control', className)}
			data-size={size}
			data-variant={variant}
			data-radius={radius}
			{...props}
		/>
	);
}

function SegmentedControlItem(props: ArkSegmentGroup.ItemProps) {
	return (
		<ArkSegmentGroup.Item className={cn('pt-segmented-control-item', props.className)} {...props} />
	);
}

function SegmentedControlItemControl(props: ArkSegmentGroup.ItemControlProps) {
	return (
		<ArkSegmentGroup.ItemControl
			className={cn('pt-segmented-control-item-control', props.className)}
			{...props}
		/>
	);
}

function SegmentedControlItemText(props: ArkSegmentGroup.ItemTextProps) {
	return (
		<ArkSegmentGroup.ItemText
			className={cn('pt-segmented-control-item-text', props.className)}
			{...props}
		/>
	);
}

function SegmentedControlIndicator(props: ArkSegmentGroup.IndicatorProps) {
	return (
		<ArkSegmentGroup.Indicator
			className={cn('pt-segmented-control-indicator', props.className)}
			{...props}
		/>
	);
}

const SegmentedControl = Object.assign(SegmentedControlRoot, {
	Root: SegmentedControlRoot,
	Item: SegmentedControlItem,
	ItemControl: SegmentedControlItemControl,
	ItemText: SegmentedControlItemText,
	Indicator: SegmentedControlIndicator,
	ItemHiddenInput: ArkSegmentGroup.ItemHiddenInput
});

export { SegmentedControl, type SegmentedControlRootProps };
